import { expandContent } from '../../../../../Common/Resources/src_front/js/satellites/expandContent';
import { initSlider } from '../initSlider';

window.addEventListener('DOMContentLoaded', onLoad, false);

function onLoad() {
    expandContent();
    initSlider();
}
